import { Grid as NovaGrid, GridProps as NovaGridProps } from '@fme-nova/components'
import { default as MuiGrid, GridProps as MuiGridProps } from '@mui/material/Grid'

import { createComponentWrapperWithRef } from '../../theme'

export const Grid = createComponentWrapperWithRef<MuiGridProps | NovaGridProps>(
  {
    mui: MuiGrid,
    nova: NovaGrid,
  },
  'Grid',
)
